module.exports = __webpack_public_path__ + "img/recall-find.af01cc4c.png";